import type { Colors } from 'styles/colors'

/**
 * Helper function to get color value from theme colors if it exists, and if not use the color
 *
 * @param color - could be a color name from our theme colors, or a hex/rgb value or a color string
 * @param themeColors - object containing all the theme colors
 * @returns color value to render
 */
export const getColor = (
    color: string | number | symbol,
    themeColors: Colors
): string =>
    Object.prototype.hasOwnProperty.call(themeColors, color)
        ? String(themeColors[color as keyof Colors])
        : String(color)

/**
 * Helper function to add 'px' unit to a number or string if it doesn't already have a unit
 * @param value
 */
export const addPxUnit = (value: string | number | undefined): string => {
    const stringValue = `${value}`
    if (!stringValue.endsWith('px') && /^\d+$/.test(stringValue)) {
        return `${stringValue}px`
    }
    return stringValue
}
